import {Button, PlusIcon} from "@/theme";

export const AddButton = ({...rest}) => {
    return (
        <>
            <Button
                icon={<PlusIcon/>}
                type="primary"
                className={'button_icon'}
                {...rest}
            />
        </>
    );
}